import { BaseModel, type RelationConfig } from './base';

import { Employee } from './employee';

// Enums

export enum CalendarFeedType {
  location = 'location',
  employee = 'employee',
}

export const CalendarFeedTypeLabels: Record<CalendarFeedType, string> = {
  [CalendarFeedType.location]: 'general.location',
  [CalendarFeedType.employee]: 'general.employee',
};

// Main Model

export class CalendarFeed extends BaseModel {
  idLocationCalendarToken!: number;
  idEmployeeCalendarToken!: number;
  type!: CalendarFeedType;
  name!: string;
  employee!: Employee | null;

  static override relations(): RelationConfig {
    return {
      employee: { type: Employee },
    };
  }

  override objectID(): string | null {
    return (this.idLocationCalendarToken || this.idEmployeeCalendarToken)?.toString() ?? null;
  }

  get isTypeLocation(): boolean {
    return this.type === CalendarFeedType.location;
  }

  get isTypeEmployee(): boolean {
    return this.type === CalendarFeedType.employee;
  }
}
